import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../AuthContext';

const PaymentSuccess = () => {
  const {user} =useAuth()
  // Inline styles
  const containerStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    backgroundColor: '#f3f4f6',
    background: 'linear-gradient(135deg, #a8e6a3, #d4f1d0)', 
  };

  const contentStyle = {
    textAlign: 'center',
    backgroundColor: '#fff',
    padding: '30px',
    borderRadius: '8px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
    maxWidth: '400px',
    width: '100%',
  };

  const successMessageStyle = {
    color: '#4caf50',
    fontSize: '2rem',
    marginBottom: '20px',
  };

  const descriptionStyle = {
    fontSize: '1.1rem',
    marginBottom: '20px',
    color: '#555',
  };

  const linkStyle = {
    display: 'inline-block',
    fontSize: '1.1rem',
    padding: '10px 20px',
    textDecoration: 'none',
    backgroundColor: '#007bff',
    color: '#fff',
    borderRadius: '4px',
    transition: 'background-color 0.3s ease',
  };

  const linkHoverStyle = {
    backgroundColor: '#0056b3',
  };

  return (
    <div style={containerStyle}>
      <div style={contentStyle}>
        <h1 style={successMessageStyle}>Payment Completed</h1>
        <p style={descriptionStyle}>
          Your payment was successful! You can now access your enrolled course in Profile.
        </p>
        <Link
          to={`/student/${user?.email}`}
          style={linkStyle}
          onMouseEnter={(e) => e.target.style.backgroundColor = linkHoverStyle.backgroundColor}
          onMouseLeave={(e) => e.target.style.backgroundColor = linkStyle.backgroundColor}
        >
          Go to Profile
        </Link>
      </div>
    </div>
  );
}

export default PaymentSuccess;
